import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/leuteliaApi";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { CalendarClock, Send, Loader2, KeyRound, ShieldAlert } from "lucide-react";

export function AccessiAccount() {
  const [logins, setLogins] = useState(null);
  useEffect(() => { api.myLogins().then((d) => setLogins(d.logins)).catch(() => setLogins([])); }, []);
  return (
    <div className="bg-white rounded-xl border border-brand-gold/25 p-5 mb-6" data-testid="accessi-card">
      <div className="flex items-start gap-3"><KeyRound size={20} className="text-brand-gold mt-0.5" />
        <div><h3 className="font-serif text-[20px] text-brand-ink leading-none">Accessi al tuo account</h3>
          <p className="text-[12.5px] text-brand-muted mt-1">Quando e da dove è stato usato il tuo account. Se un accesso arriva da un dispositivo mai visto, ti avvisiamo subito via email.</p></div></div>
      <div className="mt-3 divide-y divide-brand-gold/15">
        {logins === null ? <div className="text-[12.5px] text-brand-muted py-2">…</div> : logins.length === 0 ? <div className="text-[12.5px] text-brand-muted py-2 italic">Nessun accesso registrato.</div> : logins.map((l, i) => (
          <div key={i} className="py-2 flex flex-wrap items-center gap-2 text-[12.5px]" data-testid={`accesso-${i}`}>
            <span className="text-brand-ink font-medium">{new Date(l.at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" })}</span>
            <span className="text-brand-muted">· {l.device} · {l.where} · IP {l.ip}</span>
            {l.suspicious && <span className="ml-auto px-2 py-0.5 rounded-full bg-red-100 text-red-700 text-[10.5px] font-bold flex items-center gap-1"><ShieldAlert size={11} /> dispositivo nuovo</span>}
          </div>))}
      </div>
    </div>
  );
}

export default function Promemoria({ user, onUser }) {
  const [busy, setBusy] = useState(false);
  const toggle = async (v) => {
    try { const r = await api.setPreferences({ weekly_digest: v }); onUser({ ...user, weekly_digest: r.weekly_digest }); toast.success(v ? "Promemoria attivato: ogni lunedì alle 8:00." : "Promemoria disattivato."); }
    catch (e) { toast.error(e.message); }
  };
  const now = async () => {
    setBusy(true);
    try { const r = await api.digestSendNow(); toast.success(`Promemoria inviato a ${user.email} (${r.sent.length} hotel).`); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <div className="bg-white rounded-xl border border-brand-gold/25 p-5 mb-6" data-testid="promemoria-card">
      <div className="flex items-start gap-3">
        <CalendarClock size={20} className="text-brand-gold mt-0.5" />
        <div className="flex-1">
          <h3 className="font-serif text-[20px] text-brand-ink leading-none">Promemoria settimanale</h3>
          <p className="text-[12.5px] text-brand-muted mt-1">Ogni lunedì alle 8:00 ricevi via email cosa è cambiato dall'ultima scansione e le 3 cose da fare. Inviato a <strong>{user.email}</strong>.</p>
        </div>
        <Switch checked={!!user.weekly_digest} onCheckedChange={toggle} data-testid="promemoria-toggle" />
      </div>
      {user.role === "director" && (
        <Button onClick={now} disabled={busy} variant="outline" data-testid="promemoria-send-now" className="mt-4 h-9 rounded-lg border-brand-green/30 text-brand-green text-[12.5px] font-semibold">
          {busy ? <Loader2 size={14} className="mr-2 animate-spin" /> : <Send size={14} className="mr-2" />} Inviamelo adesso
        </Button>
      )}
    </div>
  );
}
